export const PaymentOptions = {
    Cash: 0,
    Bank: 1,
  }


